import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-internet-wifi',
  templateUrl: './page-internet-wifi.component.html',
  styleUrls: ['./page-internet-wifi.component.css']
})
export class PageInternetWifiComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
